export const state = () => ({
  pageData: null,
});

export const mutations = {
  setPageData(state, pageData) {
    state.pageData = pageData;
  },
};
